import { render, staticRenderFns } from "./InputForms.vue?vue&type=template&id=000642be&scoped=true"
import script from "./InputForms.vue?vue&type=script&lang=js"
export * from "./InputForms.vue?vue&type=script&lang=js"
import style0 from "./InputForms.vue?vue&type=style&index=0&id=000642be&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000642be",
  null
  
)

export default component.exports